import { ACTIONS } from '../actions/actionTypes';

const INITIAL_STATE = {
    questions: null,
    questionView: null,
    loading: false
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
    case ACTIONS.SET_QUESTION:
        return {...state, questions: action.payload};
    case ACTIONS.SET_QUESTION_VIEW:
        return {...state, questionView: action.payload};
    case ACTIONS.SET_QUESTION_LOADING:
        return {...state, loading: action.payload};
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/questionReducer.js